<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Devoluciones a clientes</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <button
                class="btn btn-primary btn-md btn-block"
                @click="showModalAdddevolucionNew"
                type="button"
              >
                Nueva Devolución
                <i class="fa fa-plus"></i>
              </button>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-6">
              <div action="#" class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActiva"
                  @click="filterData"
                >
                  <option value="">Todos</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="9">Anulado</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-------------------- START - tabla detalle -------------------->
        <DevolucionesTableListComponent :dataTable="data" />
        <!-------------------- END - tabla detalle ------------------->
      </div>
    </div>
    <div
      class="modal fade"
      id="modalCrearDevolucion"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Buscar factura</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <label v-if="current.scan_barra == true">Escanee factura</label>
              <label v-if="current.scan_barra == false"
                >Número de factura</label
              >
              <input
                focus
                type="text"
                v-on:keyup.enter="buscarFactura()"
                class="form-control"
                v-model="filter_.barra"
                ref="barrax"
              />
              <small class="text-danger" v-if="errors && errors.barra">{{
                errors.barra[0]
              }}</small>
            </div>
            <div v-if="current.scan_barra == false" class="col-12">
              <label>Serie de Factura</label>
              <input
                focus
                type="text"
                class="form-control"
                v-model="filter_.cargo_serie"
                ref="barrax"
              />
            </div>
            <br />
            <div v-if="current.scan_barra == false" class="col-12">
              <TiendaSelectComponent
                titulo="Seleccionar una tienda"
                :current="filter_"
              />
            </div>
            <br />
            <div class="col-12">
              <button
                @click="buscarFactura()"
                type="button"
                class="btn btn-success btn-lg btn-block"
              >
                Aceptar
                <i class="fas fa-check"></i>
              </button>
              <br />
            </div>
            <span style="font-size: 20px" class="font-weight-bold"
              >Buscar por:
            </span>
            <button
              @click="cambiarTipoScan()"
              class="btn btn-dark btn-lg btn-md btn-block"
              v-if="current.scan_barra == true"
            >
              Busqueda avanzada
            </button>
            <button
              @click="cambiarTipoScan()"
              class="btn btn-dark btn-lg btn-block"
              v-if="current.scan_barra == false"
            >
              factura
            </button>
          </div>
        </div>
      </div>
    </div>
    <CargoComponentView :dataTabla="current.detalleFact" />
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import CargoComponentView from "@/components/wms/devolucion_despacho_mayoreo/CargoComponentView";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import { mapGetters } from "vuex";
import DevolucionesTableListComponent from "@/components/wms/devolucion_despacho_mayoreo/DevolucionesTableListComponent";

export default {
  components: {
    PaginationComponent,
    CargoComponentView,
    DevolucionesTableListComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      errors: "",
      filterActiva: "",
      data: [],
      dataTabla: [],
      filter_: {},
      current: {
        detalleFact: [],
        scan_barra: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      caja: "cargos/caja",
    }),
  },
  mounted() {
    let self = this;
    self.refreshData();
  },
  methods: {
    buscarFactura() {
      let self = this;
      if (!self.filter_.barra) {
        Notifications.alert.error(
          "Buscar factura",
          "Por favor escanear antes la barra de la factura"
        );
        return;
      }
      if (self.current.scan_barra == true) {
        DynamicService.getById("cxc", "cargos", self.filter_.barra)
          .then((response) => {
            self.current.detalleFact = new Array(response.data);
            console.log(self.current.detalleFact[0]);
            $("#modalCrearDevolucion").modal("hide");
            $("#modalAdddevolucionNew").modal("show");
          })
          .catch((erros) => {
            Notifications.alert.error(
              "Buscar Factura",
              "No se encontro ninguna factura con los datos proporcionados"
            );
          });
      } else {
        self.filter_.numero = self.filter_.barra;
        DynamicService.fetch("cxc", "cargos", self.filter_)
          .then((response) => {
            if (response.data.count > 0) {
              self.current.detalleFact = response.data.results;
              console.log(self.current.detalleFact[0]);
              $("#modalCrearDevolucion").modal("hide");
              $("#modalAdddevolucionNew").modal("show");
            }
          })
          .catch((erros) => {
            Notifications.alert.error(
              "Buscar Factura",
              "No se encontro ninguna factura con los datos proporcionados"
            );
          });
      }
    },
    showModalAdddevolucionNew(detalle) {
      let self = this;
      $("#modalCrearDevolucion").modal();
    },
    cambiarTipoScan() {
      if (this.current.scan_barra == true) {
        this.current.scan_barra = false;
      } else {
        this.current.scan_barra = true;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      DevolucionesService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "wms-envio-devolucion-mayoreo-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "wms-envio-devolucion-mayoreo-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() {},
  },
};
</script>
